import "@/styles/globals.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import type { AppProps } from "next/app";
import { createTheme, MantineProvider } from "@mantine/core";
// import { VisualEditing } from "@sanity/visual-editing/next-pages-router";
// import { lazy, Suspense } from "react";

// const PreviewProvider = lazy(() => import("@/sanity/PreviewProvider"));
const theme = createTheme({});

export default function App({ Component, pageProps }: AppProps) {
  // const { draftMode, token } = pageProps;
  // return draftMode ? (
  //   <PreviewProvider token={token}>
  //     <Component {...pageProps} />
  //     <Suspense>{/* <VisualEditing /> */}</Suspense>
  //   </PreviewProvider>
  // ) : (
  return (
    <MantineProvider theme={theme}>
      <Component {...pageProps} />
    </MantineProvider>
  );
  // );
}
